// extracted by mini-css-extract-plugin
export default {"l_SwipeTextItem_main":"swipeTextItem_l_SwipeTextItem_main__zo+U6","highlight":"swipeTextItem_highlight__M4BeS"};